import React, { Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./app";
import ErrorBoundary from "./components/ErrorBoundary";
import "./i18n";
import "./styles/theme.css";
import "./styles/global.css";
import { isStandalone, clearCache } from './utils/pwaUtils';

// Auto-clean cache on PWA startup to ensure fresh content
if (isStandalone()) {
  clearCache();
}

// Prevent zoom on mobile devices
document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
}, { passive: false });

document.addEventListener('dblclick', function (e) {
  e.preventDefault();
}, { passive: false });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ErrorBoundary>
    <Router>
      <Suspense fallback={<div style={{ color: '#fff', textAlign: 'center', marginTop: '20%' }}>Loading translations...</div>}>
        <App />
      </Suspense>
    </Router>
  </ErrorBoundary>
);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then(registration => {
        console.log('SW registered: ', registration);
      })
      .catch(registrationError => {
        console.log('SW registration failed: ', registrationError);
      });
  });
}

